import React from 'react';
import { Box, Button, Card, CardContent, Container, Grid, Stack, Typography } from '@mui/material';
import { Headphones, MenuBook, Person } from '@mui/icons-material';
import { Link } from 'react-router-dom';

export default function Home(this: any) {
  return (
    <Box sx={{ bgcolor: '#f8fafc' }}>
      {/* Hero Section */}
      <Box
        sx={{
          py: { xs: 6, md: 8 },
          color: '#fff',
          background: 'linear-gradient(135deg, #1f1b2e 0%, #2d2a4a 25%, #b56829 50%, #4f46e5 75%, #1e1b4b 100%)',
        }}
      >
        <Container maxWidth="lg">
          <Stack spacing={3} sx={{ maxWidth: 800 }}>
            <Typography variant="h2" sx={{ fontWeight: 800, lineHeight: 1.1 }}>
              Dr. Darold H. Morgan
            </Typography>
            <Typography variant="h5" sx={{ opacity: 0.92, fontWeight: 400 }}>
              A lifetime dedicated to faithful preaching, thoughtful teaching, and Christian service across five decades of ministry.
            </Typography>
            <Button
              component={Link}
              to="/about"
              variant="contained"
              size="large"
              sx={{ bgcolor: '#fff', color: '#111827', width: 'fit-content', fontWeight: 700, '&:hover': { bgcolor: '#e5e7eb' } }}
            >
              Read Biography
            </Button>
          </Stack>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
        {/* Introduction Bridge */}
        <Box sx={{ mb: 8, textAlign: 'center' }}>
          <Typography variant="body1" sx={{ fontSize: '1.1rem', lineHeight: 1.8, color: '#555', maxWidth: 800, mx: 'auto' }}>
            For over five decades, Dr. Morgan's influence shaped Baptist leadership, pastoral ministry, and countless lives through preaching, teaching, and service. Explore his legacy across multiple dimensions of his remarkable life and work. This website was created by his family in honor of Darold to provide others with a place to listen to his sermons and read his written works.
          </Typography>
        </Box>

        {/* Quick Access Links */}
        <Box sx={{ textAlign: 'center', py: 6, px: 3, bgcolor: '#fafafa', borderRadius: 3, border: '1px solid', borderColor: 'divider' }}>
          <Typography variant="h4" sx={{ mb: 4, fontWeight: 700, color: '#2c3e50' }}>
            Explore His Legacy
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ justifyContent: 'center' }}>
            <Button
              component={Link}
              to="/sermon-archives"
              variant="contained"
              size="large"
              startIcon={<Headphones />}
              sx={{ fontWeight: 600, bgcolor: '#4f46e5', '&:hover': { bgcolor: '#3d37b7' }, whiteSpace: 'nowrap', '& .MuiSvgIcon-root': { fontSize: '1.2rem' } }}
            >
              Listen to Sermons
            </Button>
            <Button
              component={Link}
              to="/written-works"
              variant="contained"
              size="large"
              startIcon={<MenuBook />}
              sx={{ fontWeight: 600, bgcolor: '#8b7355', '&:hover': { bgcolor: '#6d5a43' }, whiteSpace: 'nowrap', '& .MuiSvgIcon-root': { fontSize: '1.2rem' } }}
            >
              Read Written Works
            </Button>
            <Button
              component={Link}
              to="/about"
              variant="contained"
              size="large"
              startIcon={<Person />}
              sx={{ fontWeight: 600, bgcolor: '#334155', '&:hover': { bgcolor: '#1f2937' }, whiteSpace: 'nowrap', '& .MuiSvgIcon-root': { fontSize: '1.2rem' } }}
            >
              Learn His Story
            </Button>
          </Stack>
        </Box>

        {/* Quote */}
        <Box sx={{ textAlign: 'center', py: 6, mt: 4 }}>
          <Typography variant="h6" sx={{ fontStyle: 'italic', color: '#2c3e50', fontSize: '1.2rem', fontWeight: 500 }}>
            "Love God. Love others. Serve faithfully."
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
